import { computed } from 'vue'

import { useLoadState } from '@/shared/lib'

import {
  TELEGRAM_ACCOUNT_LOAD_ERROR,
  useTelegramAccount
} from '@/apps/adok/entities/telegram-account'

export function useTelegramAccountPanel() {
  const query = useTelegramAccount()
  const { account } = query
  const { isLoading, loadError, isRetrying, retry } = useLoadState(
    TELEGRAM_ACCOUNT_LOAD_ERROR,
    query
  )

  return {
    connected: computed(() => account.value?.connected ?? false),
    username: computed(() => account.value?.username ?? ''),
    isLoading,
    loadError,
    isRetrying,
    retry
  }
}
